import { render, staticRenderFns } from "./FooterSmall.vue?vue&type=template&id=24ca97b4&scoped=true&"
var script = {}
import style0 from "./FooterSmall.vue?vue&type=style&index=0&id=24ca97b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca97b4",
  null
  
)

export default component.exports